exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-preview {\n  height: 50px;\n  width: 50px;\n  display: block\n}\n", ""]);

// exports
